import { render } from "./ConfigListaArquivosTelasView.vue?vue&type=template&id=08704d08"
import script from "./ConfigListaArquivosTelasView.vue?vue&type=script&lang=js"
export * from "./ConfigListaArquivosTelasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__